import { createElementBlock as t, openBlock as e, createElementVNode as l } from "vue";
import a from "./index289.js";
const r = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(s, o, p, m, f, i) {
  return e(), t("svg", n, o[0] || (o[0] = [
    l("path", {
      fill: "currentColor",
      d: "M12.054 4.787A18.007 18.007 0 0 1 19.95 4.6l.392.078a1.75 1.75 0 0 1 1.408 1.716v10.839a1.75 1.75 0 0 1-2.093 1.715 16.504 16.504 0 0 0-7.236.172l-.24.06a19.086 19.086 0 0 1-8.373.2l-.15-.031a1.75 1.75 0 0 1-1.408-1.716V6.794c0-1.026.878-1.828 1.935-1.74l.158.024c2.395.479 4.867.42 7.238-.173Zm7.602 1.283a16.507 16.507 0 0 0-7.238.173l-.473.118a17.94 17.94 0 0 1-7.853.195l-.073-.012a.25.25 0 0 0-.269.25v10.839a.25.25 0 0 0 .203.245l.151.03c2.552.512 5.187.449 7.712-.182l.24-.06a18.007 18.007 0 0 1 7.895-.188.25.25 0 0 0 .299-.245V6.394a.25.25 0 0 0-.201-.245ZM14.19 8.656a.75.75 0 0 1-.598 1.376 2.135 2.135 0 0 0-2.87 1.218l2.026.001a.75.75 0 0 1 .102 1.493l-.102.007h-2.025a2.135 2.135 0 0 0 2.87 1.216.75.75 0 1 1 .596 1.376 3.634 3.634 0 0 1-4.028-.755 3.644 3.644 0 0 1-.996-1.842l.09.005a.75.75 0 0 1-.102-1.493l.011-.002c.14-.676.472-1.32.997-1.845a3.635 3.635 0 0 1 4.029-.755Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ a(r, [["render", c]]);
export {
  u as default
};
